import { InstanceScreen } from 'component/navigation/instance';
import { useTranslation } from 'component/translation';
import { Stack } from 'expo-router';
import { t } from 'util/stdtypes';

export default function EditorialDashboardNewSpaceScreen() {
    const title = useTranslation(t('spaces.new_space_title', 'New space'));
    return (
        <>
            <Stack.Screen options={{ title }} />
            <InstanceScreen screenKey='spaces/new' />
        </>
    );
}
